
    import process from "process"
    window.global = window
    window.process = process
  